(function () {
  function money(cents, tpl) {
    var n = (cents / 100).toFixed(2);
    return (tpl || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, n)
                                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function init(root) {
    if (root.dataset.ahbReady) return;
    root.dataset.ahbReady = '1';

    var form = document.getElementById(root.dataset.form);
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var subToggle = root.querySelector('[data-sub-toggle]');
    var subInput = root.querySelector('[data-sub-input]');
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    function subscribed() { return !!(subInput && subInput.checked); }

    function variantInput() {
      if (!form) return null;
      return form.querySelector('input[name="id"]');
    }

    function paint() {
      tiers.forEach(function (t) {
        var on = t.querySelector('.ahb__input').checked;
        t.classList.toggle('is-selected', on);

        var useSub = subscribed() && t.dataset.subId;
        var price = parseInt(useSub ? t.dataset.subPrice : t.dataset.onePrice, 10);
        var comp = parseInt(useSub ? t.dataset.subCompare : t.dataset.oneCompare, 10);

        var pEl = t.querySelector('[data-price]');
        var wEl = t.querySelector('[data-was]');
        if (pEl) pEl.textContent = money(price, fmt);
        if (wEl) {
          if (comp > price) { wEl.textContent = money(comp, fmt); wEl.hidden = false; }
          else { wEl.hidden = true; }
        }
        if (on) {
          var id = useSub ? t.dataset.subId : t.dataset.oneId;
          var vi = variantInput();
          if (vi && id) {
            vi.value = id;
            vi.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
      if (subToggle) subToggle.classList.toggle('is-on', subscribed());
    }

    tiers.forEach(function (t) {
      t.querySelector('.ahb__input').addEventListener('change', paint);
    });
    if (subInput) subInput.addEventListener('change', paint);
    paint();
  }
  function boot() { document.querySelectorAll('[data-ahb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
